import { ModoEdicion } from "../../ui/model/catalogo-config.model";

export class ModoEdicionUtils {
    static campoDeshabilitado(modo: ModoEdicion, valor: any): boolean {
        switch (modo) {
            case 'SI':
                return false;
            case 'NO':
                return true;
            case 'VALORES':
            default:
                return valor !== undefined && valor !== null && valor !== '';
        }
    }
}